// Supabase integration - Mock mode by default
// To enable real Supabase:
// 1. Run: npm install @supabase/supabase-js
// 2. Uncomment the import below
// 3. Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to your .env file

// import { createClient } from '@supabase/supabase-js';

// For now, running in mock mode (no Supabase package required)
export const supabase = null
export const isMockMode = true

// Mock implementation - works without any dependencies
export async function saveOrder(order: any) {
  console.log('Mock Mode: Saving order', order)

  // Simulate network delay
  await new Promise((resolve) => setTimeout(resolve, 1000))

  return {
    data: {
      id: `order-${Date.now()}`,
      ...order,
      created_at: new Date().toISOString(),
    },
    error: null,
  }
}

// When you're ready to enable real Supabase, replace the above with:
/*
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const supabase = supabaseUrl ? createClient(supabaseUrl, supabaseAnonKey) : null;
export const isMockMode = !supabaseUrl;

export async function saveOrder(order: any) {
  if (isMockMode || !supabase) {
    console.log('Mock Mode: Saving order', order);
    await new Promise(resolve => setTimeout(resolve, 1000));
    return { data: { id: `order-${Date.now()}`, ...order }, error: null };
  }
  
  return await supabase.from('catering_orders').insert([order]).select();
}
*/
